import { KickbackModel } from "./kickback.model";
import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, RequestOptionsArgs, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { JQueryHelperService } from './../../shared/models/jquery-helper.service';
import { ReportFilterModel } from "../../report/models/report-filter.model";

@Injectable()
export class KickbackService {
    JQueryHelper: JQueryHelperService = new JQueryHelperService();
    constructor(private authService: AuthService,
        private http: Http) { }

    public GetKickbackRecord(input: ReportFilterModel): Observable<IAPIResponse> {
        let body = input;
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });

        return this.http.post(WeGoConfig.API_GET_KICKBACK_DATA_LIST, body, options).map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public ExportKickBackReportExcel(model: ReportFilterModel): any {
        let getUrl = WeGoConfig.API_EXPORT_KICKBACK_REPORT_EXCEL;
        let queryStringReportFilterModel = this.JQueryHelper.Param(model);
        getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);

        let headers = this.authService.GetHeader('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
        return this.http.get(getUrl, options);
    }

    public ExportKickBackReportPdf(model: ReportFilterModel): any {
        let getUrl = WeGoConfig.API_EXPORT_KICKBACK_REPORT_PDF;
        let queryStringReportFilterModel = this.JQueryHelper.Param(model);
        getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);

        let headers = this.authService.GetHeader('application/pdf');
        let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
        return this.http.get(getUrl, options);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/models/kickback.service.ts